
function normalizeVariantTitle(title) {
    return title.replace(/&amp;/g, "&").trim();

  }
  
document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll('.js.product-form__input input[type="radio"]');
  if (radios.length <= 1) return; // Exit if only one variant exists

  // Read and parse the JSON once at the start
  const variantSpecElement = document.getElementById("VariantSpecifications");
  if (!variantSpecElement) {
    console.error("VariantSpecifications JSON not found in DOM");
    return;
  }

  const productVariants = JSON.parse(variantSpecElement.textContent);
  

function updateSpecifications(variantId) {
  const normalizedVariantId = normalizeVariantTitle(variantId);
  
  const variantData = productVariants[normalizedVariantId];

  if (!variantData) {
    console.warn(`No data found for variant ID: ${variantId}`);
    return;
  }

  const productData = productVariants["product_fallback"] || {};
const mergedData = { ...productData, ...variantData };

   
  
  


  // Find the description container
  const descriptionContainer = document.querySelector('.product__metafields > .drawer-container .drawer__content');
  if (!descriptionContainer) {
    console.warn("No .drawer__content-text found in the DOM");
    return;
  }

  // Fix: Ensure we correctly extract `variant_description`
  const productDescription = productVariants["product_description"] || "No description available";
  let newDescription = variantData.variant_description;
  if (typeof newDescription === "object") {
    console.warn("Warning: Received object instead of string for description", newDescription);
    newDescription = productDescription;
  }
  newDescription = newDescription || productDescription;

  // Update the description
  descriptionContainer.innerHTML = `${newDescription}`;
  descriptionContainer.setAttribute("data-variant-description", newDescription);

  // --- Update Variant Specifications ---
const specificationsContainer = document.querySelector('.product__metafields .drawer-container .drawer__content .spec_content');
  
  if (specificationsContainer) {
    specificationsContainer.innerHTML = ""; // Clear existing content
    let table = document.createElement("table");
    let tbody = document.createElement("tbody");

    const groupedFields = {
      material: [],
      dimensions: [],
      diameter: [],
      length: []
    };

     Object.keys(mergedData).forEach(specKey => {
  if (specKey === "variant_description") return;

  const value = mergedData[specKey];
  if (!value || value.trim() === "") return;

  const lowerKey = specKey.toLowerCase();
  const baseMatch = lowerKey.match(/^(material|dimensions|diameter|length)(\d+)?$/);

  if (baseMatch) {
    const base = baseMatch[1];
    groupedFields[base].push(value);
  } else {
    const row = document.createElement("tr");
    const label = specKey.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
    row.innerHTML = `<td>${label}</td><td>${value}</td>`;
    tbody.appendChild(row);
  }
});

  Object.keys(groupedFields).forEach(base => {
    if (groupedFields[base].length > 0) {
      
      const row = document.createElement("tr");
const label = base.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
      row.innerHTML = `<td>${label}</td><td>${groupedFields[base].join(". <br>")}</td>`;
      tbody.appendChild(row);
    }
  });


    table.appendChild(tbody);
    specificationsContainer.appendChild(table);
  } 
  else {
    console.warn("Specifications container not found in the DOM.");
  }

}
 


  // Listen for variant selection changes
  radios.forEach((radio) => {
    

    radio.addEventListener("change", function () {
        const variantOptions = [];
        document.querySelectorAll('.js.product-form__input input[type="radio"]:checked').forEach((radio) => {
          variantOptions.push(radio.value);
        });
        const variantId = variantOptions.join(" / "); 
      
      updateSpecifications(variantId);
    });
  });

  // Set initial variant on load
  const selectedVariant = document.querySelector('.js.product-form__input input[type="radio"]:checked');
  if (selectedVariant) {
    
    updateSpecifications(selectedVariant.value);
  }
 });